import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CSSTransition } from "react-transition-group";
import styles from "./styles.module.css";
const ProgressBar = ({ value, showBar, bannerText, isTargetQuiz = false }) => (_jsx(CSSTransition, { in: showBar, timeout: 200, classNames: {
        enterActive: styles.MyClassEnterActive,
        enterDone: styles.MyClassEnterDone,
        exitActive: styles.MyClassExit,
        exitDone: styles.MyClassExitActive,
    }, children: _jsx("div", { className: `${styles.progress_bar_wrapper} ${bannerText !== "" ? styles.banner : ""} ${isTargetQuiz ? styles.grey : styles.tan}`, children: _jsx("div", { style: { width: `${value}%` }, className: `${styles.progress_bar} ${isTargetQuiz ? styles.green : styles.blue}` }) }) }));
export default memo(ProgressBar);
